import { type Milestone } from "@forento/core/models/milestone"
import { type ProductType } from "@forento/core/models/product"
import { getCountMilestoneCopy } from "@forento/core/utilities/milestone"

export type MilestoneFormat = "square" | "story"

export const milestoneImageWidth = 1080

export const productTypeLabels: Record<ProductType, string> = {
	course: "course",
	video: "video",
	downloadable: "download",
	session: "coaching session",
	event: "event",
}

export type CountMilestone = Extract<Milestone, { threshold: number }>

export function getMilestoneCopy(milestone: Milestone, platformName: string) {
	if (milestone.type === "product-launch") {
		const label = productTypeLabels[milestone.product.type]
		return {
			title: `New ${label} - ${milestone.product.title}`,
			caption: `Just launched a new ${label} on ${platformName}: ${milestone.product.title} 🚀`,
		}
	}
	return getCountMilestoneCopy(milestone, platformName)
}

export async function renderMilestoneImage(element: HTMLElement): Promise<Blob> {
	const { domToBlob } = await import("modern-screenshot")
	return await domToBlob(element, { scale: milestoneImageWidth / element.offsetWidth, type: "image/png" })
}

export function trackMilestoneShare(milestone: Milestone, method: string) {
	window.posthog?.capture("milestone_shared", {
		milestone_type: milestone.type,
		milestone_threshold: milestone.type === "product-launch" ? null : milestone.threshold,
		product_type: milestone.type === "product-launch" ? milestone.product.type : null,
		method,
	})
}
